import './ImageLazy.scss';
import React, { useState } from 'react';

export type ImageLazyProps = {
    height?: number;
    width?: number;
    radius?: number;
    src?: string;
    className?: string;
};

export const ImageLazy: React.FC<ImageLazyProps> = ({ height = 1, width = 1, src = '', className = '', radius = 8 }) => {
    const [isLoaded, setIsLoaded] = useState(false);

    return <div className={`preview-image-container ${className}`} style={{width: width, height: height, minWidth: width, minHeight: height, borderRadius: radius}}>
        <img 
            className={`preview-image ${isLoaded ? 'loaded' : ''}`}
            src={src} 
            loading="lazy"
            onLoad={() => setIsLoaded(true)}
        />
    </div>;
};
